module.exports = __webpack_public_path__ + "static/img/03.3f01535.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/haeusle/03.jpg
// module id = 371
// module chunks = 1